<template>
  <span
    class="match-result match-result-standard flex-center font-bold"
    v-if="!isServerSport">
    <span class="result-period color-important text-center">
      {{ customResult || matchStatus.result }}
    </span>
    <span v-if="isCricket">
      -
    </span>
    <span class="result-period color-faded text-center">
      {{ resultPeriod }}
    </span>
  </span>
  <match-results-server-sports
    class="match-result"
    :game-score="matchStatus.gameScore"
    :result-period="resultPeriod"
    :id-sport="idSport"
    v-else-if="isServerSport"
  />
</template>

<script>
import { sport, resultPeriodSPlus } from '@/services/mixins';
import MatchResultsServerSports from '@/components/templates/special-plus/MatchResultsServerSports.vue';

export default {
  name: 'MatchResults',
  mixins: [sport, resultPeriodSPlus],
  components: {
    MatchResultsServerSports,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
  },
  computed: {
    matchStatus() {
      return this.$store.getters.getMatchStatus(this.idMatch);
    },
    customResult() {
      if (this.idSport === 21) {
        const matchStatus = this.$store.getters.getMatchStatus(this.idMatch);
        const results = matchStatus.result.split(':');
        return `${results[0]}/${matchStatus.dismissals[0]}`;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.match-result {
  font-size: 0.875rem;
  padding-left: 10px;
}

.result-period {
  width: 4.1667vw;
}
</style>
